import type { PropertySetupValues } from '../propertySetup/types';

import { StayInputOverrides } from './otaParity/types';

export type StayInputsFormValues = {
  nights: number;
  baseSellPriceAud: number;
  prvInclusionsAud: number;
};

export function toStayInputs(
  values: StayInputsFormValues,
  propertySetup: Pick<PropertySetupValues, 'currency' | 'fxRate'> | null | undefined,
): StayInputOverrides {
  const currencyCode = propertySetup?.currency ?? 'AUD';
  const isNonAud = currencyCode !== 'AUD';
  const fxRate = isNonAud && propertySetup?.fxRate ? propertySetup.fxRate : 1;
  return {
    nights: values.nights,
    currencyCode,
    fxRateAudToNative: fxRate,
    baseSellPriceAud: values.baseSellPriceAud,
    prvInclusionsAud: values.prvInclusionsAud,
    prvInclusionsNative: isNonAud ? Math.round(values.prvInclusionsAud * fxRate * 100) / 100 : null,
  };
}
